import { render, staticRenderFns } from "./WizardDiscoveryConfig.vue?vue&type=template&id=0a806b6b&scoped=true&"
import script from "./WizardDiscoveryConfig.vue?vue&type=script&lang=js&"
export * from "./WizardDiscoveryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a806b6b",
  null
  
)

export default component.exports